import { useState } from "react";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import FormButton from "../../../../_shoru_shared_library/components/form/FormButton";
import FormInput from "../../../../_shoru_shared_library/components/form/FormInput";
import { addRole } from "../../../../CastingBotFirebase";

function AddRolesTab(props) {

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;

  const [name, setName] = useState('');
  const [gender, setGender] = useState('');
  const [size, setSize] = useState('');
  const [log, setLog] = useState([]);

  const logDisplay = log.map((item, index) => {
    return (
      <p key={index} style={{
        ...{marginTop: '0'},
        ...{marginBottom:'0'},
        ...{color:'#2ecc71'},
        ...{fontSize: '12px'}
      }}>
        {item}
      </p>
    )
  })

  return (
    <SubTabParent passData={props}>
      <SubTabSection>
        <FormInput required title='Name' value={name} setValue={setName} type='text' placeholder='e.g. Julius Caesar' />
        <FormInput title='Size of Role' type='text' value={size} setValue={setSize} placeholder='Unspecified' />
        <FormInput title='Gender of Character' value={gender} setValue={setGender} type='text' placeholder='Unspecified' />
        <FormButton label='Add Role' accentColour={props.accentColour} onClick={async() => {
          const role = _validateAndGetRole(name, size, gender);
          if (role !== null) {
            await addRole(role, userData.active_organisation_id, castingData.uid, setCastingData)
            .then(() => {
              setLog([('Created Role: ' + name),...log]);
            }, (rejection) => {alert('Could not create new role. Please try again.')});
          };
        }} />
        {log.length > 0? (
          <div style={{marginTop: '30px'}}>
            {logDisplay}
          </div>
        ) : null}
      </SubTabSection>
    </SubTabParent>
  )

}

export default AddRolesTab;


const _validateAndGetRole = (name, size, gender) => {
  if(name === '')
  {
    alert('Name is a required field');
    return null;
  }
  else {
    return {
      name: name,
      size: (size === '')? null : size,
      gender: (gender === '')? null : gender,
      choices: [null, null, null, null, null]
    }
  }
}